/**
 * @Time    : 2024/4/23 17:41
 * @Author  : tlovet
 * @Software: WebStorm
 */

export default {
  'app.common.option': '操作',
  'app.common.reload': '刷新',
  'app.common.refresh': '刷新',
  'app.common.detail': '详情',
  'app.common.log': '日志',
  'app.common.add': '新增',
  'app.common.edit': '编辑',
  'app.common.create': '创建',
  'app.common.update': '更新',
  'app.common.delete': '删除',
  'app.common.batchDelete': '批量删除',
  'app.common.import': '导入',
  'app.common.export': '导出',
  'app.common.apply': '申请',
  'app.common.goBack': '返回',
};
